<h2 mat-dialog-title class="dialog-header">{{'finance.invoice.details.title'|traduccion}}
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="dialog-content">


    <div class="page">

        <!-- ===== Datos de la factura + Datos del cliente ===== -->
        <div class="grid-2">
            <mat-card class="card">
                <mat-card-header>
                    <mat-card-title>{{'finance.invoice.details.data.title'|traduccion}}</mat-card-title>
                </mat-card-header>
                <mat-divider></mat-divider>

                <mat-card-content class="info-list">
                    <div class="row"><span class="label">{{'finance.invoice.details.data.serie'|traduccion}}</span> <span class="value">{{ invoice?.invoiceNumber || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.invoice.details.data.invoiceNumber'|traduccion}}</span> <span class="value">{{ invoice?.invoiceNumber || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.invoice.details.data.uuid'|traduccion}}</span> <span class="value mono">{{ invoice?.invoiceNumber || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.invoice.details.data.createdAt'|traduccion}}</span> <span class="value">{{ invoice?.createdAt ?? '' | date: appService.FORMAT_DATETIME }}</span></div>
                    <div class="row">
                        <span class="label">Tipo</span>
                        <span class="value">
                            <span class="status-chip" [ngClass]="invoice?.type == 'SIMPLIFICADA' ? 'chip-warn' : 'chip-success'">
                                {{ invoice?.type == 'SIMPLIFICADA' ? 'Simplificada' : 'Completa' }}
                            </span>
                        </span>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="card">
                <mat-card-header>
                    <mat-card-title>{{'finance.invoice.details.client.title'|traduccion}}</mat-card-title>
                </mat-card-header>
                <mat-divider></mat-divider>

                <mat-card-content class="info-list">
                    <div class="row"><span class="label">{{'finance.invoice.details.client.companyName'|traduccion}}</span> <span class="value">{{ invoice?.userFiscalData?.companyName || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.invoice.details.client.email'|traduccion}}</span> <span class="value">{{ invoice?.userFiscalData?.email || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.invoice.details.client.phone'|traduccion}}</span> <span class="value">{{ invoice?.userFiscalData?.phone || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.invoice.details.client.cardId'|traduccion}}</span> <span class="value">{{ invoice?.userFiscalData?.cardId || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.invoice.details.client.address'|traduccion}}</span> <span class="value">{{ invoice?.userFiscalData?.address || '—' }}</span></div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- ===== Servicios (con totales en el footer) ===== -->
        <mat-card class="card">
            <mat-card-header>
                <mat-card-title>{{'finance.invoice.details.services'|traduccion}}</mat-card-title>
            </mat-card-header>
            <mat-divider></mat-divider>

            <div class="table-wrap invoice-services-desktop-view">
                <app-data-table
                    preset="modal"
                    [dataSource]="dataSource"
                    [displayedColumns]="cols"
                    tableClass="w-full"
                    emptyIcon="inbox"
                    [emptyMessage]="'finance.invoice.details.service.nodata'|traduccion">

                    <!-- Servicio -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="thead">{{'finance.invoice.details.service'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">
                            <div class="name">{{ r.name }}</div>
                            <div class="muted mono" *ngIf="r.reference">Ref: {{ r.reference }}</div>
                        </td>
                    </ng-container>

                    <!-- Periodo -->
                    <ng-container matColumnDef="amount">
                        <th mat-header-cell *matHeaderCellDef class="thead">{{'finance.invoice.details.service.amount'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">{{ r.amount }}</td>
                    </ng-container>

                    <!-- Base -->
                    <ng-container matColumnDef="basePrice">
                        <th mat-header-cell *matHeaderCellDef class="thead">{{'finance.invoice.details.service.basePrice'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">{{ r.basePrice | currency:'EUR' }}</td>
                    </ng-container>

                    <!-- IVA -->
                    <ng-container matColumnDef="tax">
                        <th mat-header-cell *matHeaderCellDef class="thead">{{'finance.invoice.details.service.tax'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">{{ r.tax }}</td>
                    </ng-container>

                    <!-- Total -->
                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef class="thead">{{'finance.invoice.details.service.total'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">{{ r.total | currency:'EUR' }}</td>
                    </ng-container>

                </app-data-table>
            </div>

            <div class="invoice-services-mobile-view" *ngIf="dataSource.data?.length; else mobileInvoiceEmpty">
                <div class="invoice-service-mobile-card" *ngFor="let r of dataSource.data">
                    <div class="invoice-service-mobile-main">
                        <div class="invoice-service-mobile-name">{{ r.name }}</div>
                        <div class="invoice-service-mobile-ref mono" *ngIf="r.reference">Ref: {{ r.reference }}</div>
                    </div>

                    <div class="invoice-service-mobile-grid">
                        <div class="invoice-service-mobile-item">
                            <span class="invoice-service-mobile-label">{{'finance.invoice.details.service.amount'|traduccion}}</span>
                            <strong>{{ r.amount }}</strong>
                        </div>
                        <div class="invoice-service-mobile-item">
                            <span class="invoice-service-mobile-label">{{'finance.invoice.details.service.basePrice'|traduccion}}</span>
                            <strong>{{ r.basePrice | currency:'EUR' }}</strong>
                        </div>
                        <div class="invoice-service-mobile-item">
                            <span class="invoice-service-mobile-label">{{'finance.invoice.details.service.tax'|traduccion}}</span>
                            <strong>{{ r.tax }}</strong>
                        </div>
                        <div class="invoice-service-mobile-item">
                            <span class="invoice-service-mobile-label">{{'finance.invoice.details.service.total'|traduccion}}</span>
                            <strong>{{ r.total | currency:'EUR' }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #mobileInvoiceEmpty>
                <div class="invoice-services-mobile-empty">{{'finance.invoice.details.service.nodata'|traduccion}}</div>
            </ng-template>

            <!-- Totales (desglose) + Acciones en el cuerpo -->
            <mat-divider></mat-divider>

            <div class="services-footer">
                <!-- Acciones -->
                <div class="actions">
                    <button mat-raised-button color="primary" (click)="convertToFull()"
                        [disabled]="invoice?.type != 'SIMPLIFICADA'">
                        {{'finance.invoice.details.action.convertToFull'|traduccion}}
                    </button>
                    <button mat-stroked-button (click)="print()">
                        <mat-icon>print</mat-icon> {{'finance.invoice.details.action.print'|traduccion}}
                    </button>
                    <button mat-stroked-button (click)="downloadPdf()">
                        <mat-icon>download</mat-icon> {{'finance.invoice.details.action.downloadInvoice'|traduccion}}
                    </button>
                    <button mat-stroked-button (click)="sendByEmail()">
                        <mat-icon>mail</mat-icon> {{'finance.invoice.details.action.sendByEmail'|traduccion}}
                    </button>
                </div>

                <!-- Totales -->
                <div class="totals-box">
                    <div class="line">
                        <span>{{'finance.invoice.details.totals.base'|traduccion}}</span>
                        <span class="strong">{{ totals.base | currency:'EUR' }}</span>
                    </div>
                    <div class="line">
                        <span>{{'finance.invoice.details.totals.tax'|traduccion}} ({{ 21 }}%)</span>
                        <span class="strong">{{ totals.tax }}</span>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="line total-line">
                        <span>{{'finance.invoice.details.totals.total'|traduccion}}</span>
                        <span class="strong">{{ totals.total | currency:'EUR' }}</span>
                    </div>
                </div>
            </div>

        </mat-card>

    </div>



</mat-dialog-content>
